import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";

import { HoverHintDefinitionGrid } from "@/components/ui/HoverHintDefinitionGrid";
import { buildGipiPeekRows } from "@/lib/gipiPeekRows";
import {
  fetchPurchaseInvoiceDetail,
  purchaseInvoiceDetailQueryKey,
} from "@/pages/mrp/purchaseInvoiceApi";

export function GipiDetailHoverHint({
  purchaseInvoiceId,
  vendorInvoiceNumber,
}: {
  purchaseInvoiceId: number;
  vendorInvoiceNumber?: string | null;
}): JSX.Element {
  const detailQuery = useQuery({
    queryKey: purchaseInvoiceDetailQueryKey(purchaseInvoiceId),
    queryFn: () => fetchPurchaseInvoiceDetail(purchaseInvoiceId),
    staleTime: 30_000,
  });

  if (detailQuery.isLoading) {
    return (
      <p className="flex items-center gap-1.5 text-xs text-slate-600">
        <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden />
        Loading GIPI…
      </p>
    );
  }

  if (detailQuery.isError || detailQuery.data == null) {
    return <p className="text-xs text-slate-600">Could not load GIPI preview.</p>;
  }

  return (
    <HoverHintDefinitionGrid
      rows={buildGipiPeekRows(detailQuery.data.purchase_invoice, detailQuery.data.lines, {
        vendorInvoiceNumber,
      })}
    />
  );
}
